import { ApiService } from "@core/api/api-service";
import { ServerConfig } from "@domain/server-config/server-config";

export class ServerConfigService {
	constructor(private readonly apiService: ApiService) {}

	async getConfig(): Promise<ServerConfig> {
		const result = await this.apiService.get<ServerConfig>("/config");
		return result.data;
	}
}
